const UxDesignSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
        <g clipPath="url(#clip0_307_12168)">
            <path d="M51.5919 26.1224C51.5919 40.1888 40.1888 51.5918 26.1225 51.5918C12.0561 51.5918 0.653076 40.1888 0.653076 26.1224C0.653076 12.0561 12.0561 0.653023 26.1225 0.653023C40.1888 0.653023 51.5919 12.0561 51.5919 26.1224Z" stroke="#D100C9" strokeWidth="2" />
            <path d="M63.3469 32C63.3469 46.0663 51.9439 57.4694 37.8776 57.4694C23.8112 57.4694 12.4082 46.0663 12.4082 32C12.4082 17.9336 23.8112 6.53059 37.8776 6.53059C51.9439 6.53059 63.3469 17.9336 63.3469 32Z" stroke="#D100C9" strokeWidth="2" />
            <path d="M51.5919 37.8775C51.5919 51.9439 40.1888 63.3469 26.1225 63.3469C12.0561 63.3469 0.653076 51.9439 0.653076 37.8775C0.653076 23.8112 12.0561 12.4081 26.1225 12.4081C40.1888 12.4081 51.5919 23.8112 51.5919 37.8775Z" stroke="#D100C9" strokeWidth="2" />
        </g>
        <defs>
            <clipPath id="clip0_307_12168">
                <rect width="64" height="64" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default UxDesignSvg; 